import React from 'react';
import ReactDOM from "react-dom";
import HelpComponent from '../HelpComponent';
import { format } from "date-fns";

class OverlayOption extends React.Component{
    constructor() {
        super();
        this.sidebarChange = this.sidebarChange.bind(this);
        this.deleteLayerList = this.deleteLayerList.bind(this);
        this.gotoLayer = this.gotoLayer.bind(this);
        this.state = {
            opacity : "",
            helpMode : "None"
        };
    }    
    componentWillMount(){  
        if (this.props.layer.layerType == "Overlay") {
            const layerName = this.props.layer.layerName;
            const defaultOpacity = window.main.OView.getTerrainOverlay(layerName).opacity * 100;
            this.setState({opacity:defaultOpacity});
        }
    }
    sidebarChange(event){
        const layerName = this.props.layer.layerName;
        window.main.OView.getTerrainOverlay(layerName).opacity = event.target.value/100;
        const defaultOpacity = window.main.OView.getTerrainOverlay(layerName).opacity * 100;
        this.setState({opacity:defaultOpacity});
    }
    deleteLayerList(layer){
        const Layer = {
            TITLE:layer.layerName,
            TYPE:layer.layerType
        };
        this.props.deleteLayerList(Layer);
    }
    gotoLayer(){
        var Pos = new window.Geo3DPoint(121.2347878442796,23.427553934089445,465850.0013822634);
        var V = new window.Geo3DPoint(0,0,-1);
        var Up = new window.Geo3DPoint(0,1,0);
        var Camera = new window.ov.Camera(Pos,V,Up);
        window.main.OView.gotoCamera(Camera, true);
    }
    onHelpClick(mode){
        this.setState({helpMode:mode})
    }
    render(){
        const Layer = this.props.layer;
        const siderRangeCSS ={
            background: "linear-gradient(45deg, rgba(59,173,227,1) 0%, rgba(87,111,230,1) 25%, rgba(152,68,183,1) 51%, rgba(255,53,127,1) 100%)"
        };
        if(this.state.helpMode === "Layer2DHelp" ){
            ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/Hgt-xaw9AX8" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
        }   
        else if(this.state.helpMode === "None"){
            ReactDOM.unmountComponentAtNode(document.getElementById('Help'));      
        }
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <div className="ts fourteen wide column"  >
                        <h6 className="layerNameCSS">{Layer.layerName}
                            <button className="ts circular pulsing mini icon button" style={{fontSize:"10px"}} onClick={(e)=>this.onHelpClick("Layer2DHelp")}>
                                <i className="help small icon" style={{color:"#919191"}}></i>
                            </button>
                        </h6>
                    </div>                    
                    {
                        (Layer.layerType === "Overlay") ? 
                            <label className="ts two wide column right aligned">{(this.state.opacity).toFixed(1)}%</label>
                        : null
                    }
                </div>  
                {
                    (Layer.layerType === "Overlay") ? 
                        <div>                    
                            <input type="range" min="0" max="100" defaultValue={this.state.opacity} step="1" onChange={(e)=>this.sidebarChange(e)} style={siderRangeCSS}></input>
                        </div> : null
                }              
                <div className="ts grid">
                    <div className="ts two wide column" id="removeLayerIcon" onClick={(e)=>this.deleteLayerList(Layer)}>
                        <i className="remove circle outline icon"></i>
                    </div>
                    <div className="ts twelve wide column"></div>
                    <div className="ts two wide column" id="gotoLayerIcon" onClick={(e)=>this.gotoLayer()}>
                        <i className="marker icon"></i>
                    </div>
                </div>
            </div>
        );
    }
}

class OverlayLayer extends React.Component{
    constructor() {
        super();        
        this.state = {
            List:[],
            Data:{}
        };
        this.wmtsLayerChecked = this.wmtsLayerChecked.bind(this);
    }
    componentWillMount(){
        var layerThis = this;
        const WMTSLayerList = window.LAYER_GROUP_2DWMTS.WMTS_LAYERS;
        window.LAYER_GROUP_2DWMTS.WMTS_GROUP.map(
            (layers) =>
            window.ov.getWMTSLayerInfo(layers.URL,function(e){
                if(e.url&&e.identifier){
                    WMTSLayerList.push({
                        TITLE:e.title||e.identifier,
                        TYPE:"Overlay",
                        ID:e.identifier,
                        URL:e.url,
                        CHECKED:false
                    });
                }
                layerThis.setState({List:WMTSLayerList});
            })
        )
    }
    componentDidUpdate(prevProps, prevState, snapshot){
        const layerList = this.state.List;
        if (prevProps.currentTime!==this.props.currentTime) {
            for (var i in layerList) {
                if (layerList[i].CHECKED && layerList[i].TYPE == "ConditionOverlay" && layerList[i].TIMELINE !== undefined) {
                    this.changeSetting(layerList[i], i);
                }
            }
        }
        if(this.props.deleteList.layerType === "Overlay" || this.props.deleteList.layerType == "ConditionOverlay"){
            for (let i = 0, len = this.state.List.length; i < len; i++){
                if (layerList[i].TITLE === this.props.deleteList.layerName){
                    if(layerList[i].CHECKED){
                        layerList[i].CHECKED = !layerList[i].CHECKED;
                        let layername = (layerList[i].TYPE === "ConditionOverlay") ? layerList[i].LAYERNAME : layerList[i].TITLE;
                        window.main.OView.removeTerrainOverlay(layername);
                        window.alertify.error("已關閉圖層："+layerList[i].TITLE);                        
                        this.setState({List:layerList});
                        return ;
                    }
                }
            }
        }
    }
    changeSetting(layer, index) {
        let layerThis = this;
        let Data = layerThis.state.Data;
        let current = format(layer.TIMELINE.SELECTEDINTERVAL[0],'yyyyMMddHH');
        if (layerThis.props.currentTime.length != 0)
            current = format(layerThis.props.currentTime[0],'yyyyMMddHH');
        if (!Data.hasOwnProperty(layer.ID)) {

        } else {
            if (!Data[layer.ID].hasOwnProperty(current)) {

            } else {
                let data = Data[layer.ID];
                let setting = {
                    url: window.LOCAL_SERVER.URL,
                    layerName: layer.ID,
                    drawColor: layer.DRAWCOLOR,
                    fillColor: layer.FILLCOLOR,
                    conditions: layer.CONDITIONS,
                    extraSettings: layer.EXTRASETTINGS
                };
                let cond = {};
                if (layer.ID == "taipei_vd") {
                    cond = {
                        "#FF009900" : [],
                        "#FFFF9900" : [],
                        "#FFFF0000" : [],
                        "#FFAAAAAA" : [],
                    }
                    for (var id in data[current]) {
                        data[current][id] > 35 ? cond["#FF009900"].push("'"+id+"'") :
                        data[current][id] > 15 ? cond["#FFFF9900"].push("'"+id+"'") :
                        data[current][id] > 0 ? cond["#FFFF0000"].push("'"+id+"'") :
                        cond["#FFAAAAAA"].push("'"+id+"'");
                    }
                    for (var color in cond) {
                        setting.conditions.push({
                            SQL: "VD編號 IN ("+cond[color].join(',')+")",
                            DrawColor: color
                        });
                    }
                } else {
                    cond = {
                        "#FFd82226" : [],
                        "#FFe94529" : [],
                        "#FFe36825" : [],
                        "#FFf18624" : [],
                        "#FFee9c26" : [],
                        "#FFf4c723" : [],
                        "#FFd4ca2a" : [],
                        "#FFa2bd3c" : [],
                        "#FF6cad47" : [],
                        "#FF25a44b" : [],
                        "#0025a44b" : []
                    };
                    for (var id in data[current]) {
                        data[current][id] > 140 ? cond["#FFd82226"].push(id) :
                        data[current][id] > 120 ? cond["#FFe94529"].push(id) :
                        data[current][id] > 110 ? cond["#FFe36825"].push(id) :
                        data[current][id] > 105 ? cond["#FFf18624"].push(id) :
                        data[current][id] > 90 ? cond["#FFee9c26"].push(id) :
                        data[current][id] > 80 ? cond["#FFf4c723"].push(id) :
                        data[current][id] > 60 ? cond["#FFd4ca2a"].push(id) :
                        data[current][id] > 50 ? cond["#FFa2bd3c"].push(id) :
                        data[current][id] > 30 ? cond["#FF6cad47"].push(id) :
                        data[current][id] > 0 ? cond["#FF25a44b"].push(id) :
                        cond["#0025a44b"].push(id);
                    }
                    for (var color in cond) {
                        setting.conditions.push({
                            SQL: "grid_ID IN ("+cond[color].join(',')+")",
                            FillColor: color
                        });
                    }
                }
                window.main.OView.setConditionOverlayLayer(setting, function (e) {
                    if(e.success){
                        let list = layerThis.state.List;
                        if (!layer.CHECKED) {
                            window.alertify.success("已開啟圖層："+layer.TITLE);
                            layerThis.props.setOpenLayer(layer,null);
                            list[index].CHECKED = !layer.CHECKED;
                            list[index].LAYERNAME = e.layername;
                        } else {
                            list[index].LAYERNAME = e.layername;
                        }
                        layerThis.setState({List:list});
                    } else if (!e.success) {
                        if (!layer.CHECKED)
                            window.alertify.error("開啟圖層失敗："+layer.TITLE);
                    }
                });
            }
        }
    }
    wmtsLayerChecked(layer,index){
        const list = this.state.List;
        const LayerEPSG = layer.EPSG || 3857;
        const layerThis = this;             
        if(!layer.CHECKED){
            if(this.props.LayerLength<15){
                switch(layer.TYPE) {
                    case "ConditionOverlay":
                        list.forEach(function (l) {
                            if (l.CHECKED && l.TYPE == "ConditionOverlay" && l.TITLE !== layer.TITLE)
                                window.main.OView.removeTerrainOverlay(l.LAYERNAME);
                                l.CHECKED = false;
                        });
                        if (layer.TIMELINE !== undefined)
                            layerThis.props.setTimeLineContent(layer.TIMELINE);
                        let Data = this.state.Data;
                        let current = format(layer.TIMELINE.SELECTEDINTERVAL[0],'yyyyMMddHH');
                        const data= { time: current };
                        const formData = Object.keys(data).map(
                            function (keyName) {
                                return encodeURIComponent(keyName) + '=' + encodeURIComponent(data[keyName])
                            }
                        ).join('&');
                        if (!Data.hasOwnProperty(layer.ID)) {
                            fetch(layer.FETCHURL, {
                                    method: "POST",
                                    body: formData,
                                    headers: new Headers({
                                        "Content-type": "application/x-www-form-urlencoded"
                                    })
                                })
                                .then(res => res.json())
                                .then(data => {
                                    Data[layer.ID] = data;
                                    this.setState({Data});
                                    this.changeSetting(list[index], index);
                                })
                                .catch(e => {
                                    console.log("取得資料失敗");
                                })
                        } else {
                            this.changeSetting(list[index], index);
                        }
                        break;
                    case "Overlay":
                        window.main.OView.addTerrainWMTSOverlay({
                            url: layer.URL,
                            identifier: layer.ID,
                            layername: layer.TITLE,
                            pgmapserver: false,
                            epsg: LayerEPSG,
                            urlTemplate: "{URL}"
                        }, function (e) {
                            if(e){
                                window.alertify.success("已開啟圖層："+layer.TITLE);
                                layerThis.props.setOpenLayer(layer,null);                        
                                list[index].CHECKED = !layer.CHECKED;
                                layerThis.setState({List:list});
                            }
                            else if(!e){
                                window.alertify.error("開啟圖層失敗："+layer.TITLE);
                            }
                        });
                        break;
                    defalt:
                        break;
                }
            }
            else{
                window.alertify.error("為維持較好的使用效能，已達WMTS圖層開啟上限15張");
            }                     
        }
        else{
            let layername = (layer.TYPE === "ConditionOverlay") ? list[index].LAYERNAME : layer.TITLE;
            window.main.OView.removeTerrainOverlay(layername);
            layerThis.props.deleteLayer(layer);
            window.alertify.error("已關閉圖層："+layer.TITLE);            
            list[index].CHECKED = !layer.CHECKED;    
            layerThis.setState({List:list});
            if (layer.TIMELINE !== undefined)
                layerThis.props.setTimeLineSwitch();
        }
                      
    }
    render(){
        const List =this.state.List;
        return( 
            <div className="ts checkboxes">
                {
                    List.map(
                        (layers,index)=>                    
                        <div className="ts checkbox" data-tooltip={layers.TITLE}>
                            <input type="checkbox" name="wmtslayers" id={layers.TITLE} onChange={(e)=>this.wmtsLayerChecked(layers,index)} checked={layers.CHECKED}></input>
                            <label htmlFor={layers.TITLE}>{layers.TITLE}</label>
                        </div>
                    )
                }
            </div>           
        );
    }
}

export {OverlayLayer,OverlayOption} ;